import { STYLE_OPTIONS } from 'src/constants';

const fontWeight = 400;

const buttonBoxStyle = () => ({
  rootBox: {},

  buttonEdit: {
    ...STYLE_OPTIONS.BUTTON_PRIMARY,
    fontWeight,
  },

  buttonView: {
    ...STYLE_OPTIONS.BUTTON_PRIMARY_REVERSED,
    fontWeight,
  },

  buttonDelete: {
    ...STYLE_OPTIONS.BUTTON_PRIMARY,
    backgroundColor: STYLE_OPTIONS.COLOR_RED,
    boxShadow: `0px 0px 0px 1px ${STYLE_OPTIONS.COLOR_RED}`,
    fontWeight,
  },

  buttonVideo: {
    paddingTop: 0,
  }
});

export default buttonBoxStyle;
